//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class="mainlayout">

    <div class="top-panel">
      <div class="top-panel-logo-panel" :class="{'top-panel-logo-panel-grey': mainMenuType.value != mainMenuType.FULLWIDTH}">
        <div class="top-panel-logo-panel-icon"><Icon type="cube"></Icon></div>
        <div class="top-panel-logo-panel-text">
          <div>{{appSettings.appName}}</div>
          <div class="top-panel-logo-panel-text-ver">{{appSettings.appVer}}</div>
        </div>
        <Button class="top-panel-logo-panel-button" type="text" @click="mainMenuOnClick">
          <Icon type="navicon"></Icon>
        </Button>
      </div>
      <!--div style="float:left">
        <Button type="text" class="top-panel-toggle-mainmenu-button" @click="mainMenuToggleCollapseMenuOnClick">
          <Icon :type="mainMenuType.value != mainMenuType.FULLWIDTH ? 'chevron-right' : 'chevron-left'"></Icon>
        </Button>
      </div-->
      <!--div style="padding-top:3px; width:60px; font-size:9.5px; color:#bbb; float:left">
        К: {{appLoadingTimes.avgTime}}<br>
        И: {{serverStatus.serverConnecting.avgTime}}<br>
        С: {{serverStatus.serverLoading.avgTime}}<br>
        Ж:{{serverStatusExecutionTime}}<br>
        Б: {{serverStatus.dbConnecting.avgTime}} {{serverStatus.dbConnecting.error}}<br>
      </div-->
      <div style="padding-top:18px;padding-left:10px; float:left">
        {{time | formatDate('timeWithoutSeconds')}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      </div>
      <div style="padding-top:18px; float:left">
        {{(appSettings.server.host == 'https://s2.rokkets.ru:1776/api/') ? appSettings.company.name : appSettings.company.name + ' DEV '+ appSettings.server.host}}
      </div>
      <div style="position: absolute; top:8px; right:20px;">
         <font size="3px" v-if="activeUser">
           {{activeUser.Name}}
           <Button size="large" type="text" @click="logoutOnClick">
             <Icon type="power" size="15"></Icon> Выход
           </Button>
         </font>
      </div>
    </div>

    <div class="mainmenu-panel" :class="{'mainmenu-panel-narrow': mainMenuType.value == mainMenuType.NARROW, 'mainmenu-panel-collapsed': mainMenuType.value == mainMenuType.COLLAPSED}">
      <div class="mainmenu-panel-hide-scroll-inner" :class="{'mainmenu-panel-hide-scroll-inner-narrow': mainMenuType.value == mainMenuType.NARROW}">

        <MainMenu class="mainmenu mainmenu-style" @returninstance="setMainMenuInstance"/>

        <div class="mainmenu-footer" v-if='mainMenuType.value == mainMenuType.FULLWIDTH'>
          <div class="mainmenu-footer-hr"></div>
          <div>
            <br><br>&copy; ROKKETS, 2021
          </div>
        </div>

      </div>
    </div>

    <div class="content" :class="{'content-with-narrow-mainmenu': mainMenuType.value == mainMenuType.NARROW, 'content-with-fullwidth-mainmenu':mainMenuType.value == mainMenuType.FULLWIDTH}">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>

  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'

import realtimeServerDataManager from '@/technical/realtimeServerDataManager'
// import mainCommonDataLoader from './mainCommonDataLoader'
// import serverErrorHandling from '@/technical/serverErrorHandling'

import MainMenu from './MainMenu/MainMenu.vue'

import Vue from 'vue'
import VueSailsIO from 'vue-sails.io'

export default {
  components: { MainMenu },
  data () {
    return {
      serverStatus: {serverLoading: {avgTime: 0}, dbConnecting: {avgTime: 0, error: ''}, serverConnecting: {avgTime: 0}},
      appLoadingWatcherTimeoutPeriod: 5000, // ms
      appLoadingWatcherFnIsWorking: false,
      appLoadingTimes: {avgTime: 0, curIteration: 0, iterations: [{dur: 0}, {dur: 0}, {dur: 0}, {dur: 0}, {dur: 0}]}, // iterations - array of obj { startTick:0, duration:0}
      time: Date.now()
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'i18n',
      'activeUser',
      'mainMenuType',
      'commonData' // for realtimeServerDataManager
    ]),
    serverStatusExecutionTime: function () {
      var returnTime = ''
      var theTime = this.serverStatus.executionTime

      if (theTime >= 24 * 3600 * 1000) {
        returnTime += Math.round(theTime / (3600 * 24 * 1000)) + 'д '
        theTime = theTime % (3600 * 24 * 1000)
      }
      if (theTime >= 3600 * 1000) {
        returnTime += Math.round(theTime / (3600 * 1000)) + 'ч '
        theTime = theTime % (3600 * 1000)
      }
      if (theTime >= 60 * 1000) {
        if (this.serverStatus.executionTime < 24 * 3600 * 1000) returnTime += Math.round(theTime / (60 * 1000)) + 'м '
        theTime = theTime % (60 * 1000)
      }
      if (this.serverStatus.executionTime < 3600 * 1000) {
        returnTime += Math.round(theTime / 1000) + 'c'
      }
      return returnTime
    }
  },
  created: function () {
    // var thisRef = this

    var mainMenuTypeValue = Number(localStorage.getItem('BMSClient.mainMenuType'))
    if (mainMenuTypeValue != null) this.mainMenuTypeSet(mainMenuTypeValue)

    var thisRef = this
    function appLoadingWatcher () {
      // если пришло время нового вызова watcher по интервалу, а watcher еще не закончил работать, то выходим и новый запуск тем самым закончится. старый доработает. а там снова будет вызов
      if (thisRef.appLoadingWatcherFnIsWorking === true) return

      thisRef.appLoadingWatcherFnIsWorking = true

      thisRef.appLoadingTimes.iterations[thisRef.appLoadingTimes.curIteration].startTick = new Date().getTime()
      setTimeout(function () {
        thisRef.appLoadingTimes.iterations[thisRef.appLoadingTimes.curIteration].dur = new Date().getTime() - thisRef.appLoadingTimes.iterations[thisRef.appLoadingTimes.curIteration].startTick

        thisRef.appLoadingTimes.curIteration++
        if (thisRef.appLoadingTimes.curIteration === 5) thisRef.appLoadingTimes.curIteration = 0

        thisRef.appLoadingTimes.avgTime = (thisRef.appLoadingTimes.iterations[0].dur + thisRef.appLoadingTimes.iterations[1].dur + thisRef.appLoadingTimes.iterations[2].dur + thisRef.appLoadingTimes.iterations[3].dur + thisRef.appLoadingTimes.iterations[4].dur) / 5

        thisRef.appLoadingTimes.iterations[thisRef.appLoadingTimes.curIteration].startTick = new Date().getTime()
        setTimeout(appLoadingWatcher, thisRef.appLoadingWatcherTimeoutPeriod)
        thisRef.appLoadingWatcherFnIsWorking = false
      }, 0)
    }

    function getServerStatusWatcher () {
      /* thisRef.serverStatus.serverConnecting.startTick = new Date().getTime()

      http.get(thisRef.appSettings.server.host + thisRef.appSettings.server.serverStatus)
      .then(function (response) {
        var serverConnectingTime = new Date().getTime() - thisRef.serverStatus.serverConnecting.startTick
        thisRef.serverStatus = response.data
        thisRef.serverStatus.serverConnecting = {avgTime: serverConnectingTime}
        setTimeout(getServerStatusWatcher, 5000)
      })
      .catch(function (error) {
        if (error.response) {
          thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + error.response.data.error)
        } else {
          thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
          thisRef.appStateServerConnectedSet(false)
          thisRef.$router.push('/serverisnotavailable')
        }
      }) */
    }

    getServerStatusWatcher()
    appLoadingWatcher()

    function getCurrentTime () {
      thisRef.time = Date.now()
    }
    setInterval(getCurrentTime, 1000)

    // преобразуем http://localhost:1777/api/ в http://localhost:1777 чтобы sails socket достучался
    // пустым второй параметр нельзя оставлять тогда ошибка в console выдется
    // Vue.use(VueSailsIO, .substr(0, this.appSettings.server.host.substr(0, serverUrl.lastIndexOf('/')).lastIndexOf('/')) + '/')
    Vue.use(VueSailsIO, 'http://no_url') // !!!!!!!!!!!!!!!!?????????????? Вроде он должен пробовать логинится по этому адресу но на практике логинится уже по нормальному
    this.$sails.sails.reconnection = true // устанавливаем глобальный флаг реконнектится в случае если сокет раздисконнетится
    /*
    realtimeServerDataManager(this.$sails, this.appSettings, function () {
      mainCommonDataLoader({all: true}, function (error) {
        if (error) return serverErrorHandling(error, thisRef)
        else thisRef.commonDataIsLoadedSet(true)
      })
    })
    */
    realtimeServerDataManager(this, function () {
      thisRef.mainMenuInstance.makeMainMenu()
    })
  },
  methods: {
    // этот метод нужен чтобы получить доступ к экземпляру компонента MainMenu, чтобы потом когда будут загружены из бд все CommonData (включая settings такие
    // как MainMenuPermissionsByUserGroups которые необходимы для построения MainMeny) вызвать у этого экземпляра makeMainMenu
    setMainMenuInstance (val) {
      this.mainMenuInstance = val
    },
    mainMenuOnClick () {
      switch (this.mainMenuType.value) {
        case this.mainMenuType.FULLWIDTH:
          this.mainMenuTypeSet(this.mainMenuType.NARROW)
          break
        case this.mainMenuType.NARROW:
          this.mainMenuTypeSet(this.mainMenuType.COLLAPSED)
          break
        case this.mainMenuType.COLLAPSED:
          this.mainMenuTypeSet(this.mainMenuType.FULLWIDTH)
          break
      }
    },
    mainMenuToggleCollapseMenuOnClick () {
      if (this.mainMenuType.value === this.mainMenuType.FULLWIDTH) {
        this.mainMenuTypeSet(this.mainMenuType.NARROW)
      } else {
        this.mainMenuTypeSet(this.mainMenuType.FULLWIDTH)
      }
    },
    mainMenuShowHideMenuOnClick (indx) {
      if (this.mainMenuType.value === this.mainMenuType.COLLAPSED) {
        this.mainMenuTypeSet(this.mainMenuType.FULLWIDTH)
      } else {
        this.mainMenuTypeSet(this.mainMenuType.COLLAPSED)
      }
    },
    logoutOnClick () {
      var thisRef = this

      http.get(this.appSettings.server.host + this.appSettings.server.userLogout)
      .then(function (response) {
        // !!! ранее удаление из localStorage было тут. но если сервер недоступен (отвалился) то разлогинится вообще не получится. а тут хотя бы в браузере
        // !!! тогда что тут?
      })
      .catch(function (error) {
        if (error.response) {
          thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + error.response.data.error)
        } else {
          thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
          thisRef.appStateServerConnectedSet(false)
          thisRef.$router.push('/serverisnotavailable')
        }
      })

      // здесь не через vuejs router чтобы страница какбы обновилась и все сомпоненты приложения vuejs обнулились. иначе после перелогина открытые ранее страниы сохраняют старые значения
      window.location.href = '/welcome'
      thisRef.activeUserSet(null)
      // localStorage.removeItem('BMSClient2017ActiveUser')
    },
    ...mapMutations([
      'mainMenuTypeSet',
      'activeUserSet',
      'commonDataIsLoadedSet'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
@import "./MainLayout.css";
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// MainLayout.vue?4740033e